var cov_1edxmodzf7 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/context/index.ts",
      hash = "901366abf564ac566e4d93f4660c2be6c06eb94e",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/context/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

// copy from https://github.com/jamiebuilds/create-react-context
// Solve the version conflict between create-react-context and react17
import React from 'react';
export default React.createContext;